import { GroupRoles } from "@dashboard/devices/types";
import { rolesOptions } from "@dashboard/shared/roles";
import { Typography } from "@mui/material";

// Renders a member's role as read-only, translated text (used when the viewer cannot edit roles).
export const RoleLabel = ({ role }: { role: GroupRoles | null | undefined }) => {
    const label = rolesOptions.find((option) => option.value === role)?.label ?? "";
    return <Typography>{label}</Typography>;
};
